// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1__kP","cls2":"Loading-cls2_4lv Loading-cls1__kP"};